<template>
    <div>
        <input type="text" class="form-control" v-model="handler" @input="change">
    </div>

</template>
<script>

export default {
  props: ['config', 'name', 'value'],
  data(){
      return {
          handler:'',
      }
  },
  mounted(){
      var text = this.value;
      text = ''+text;
      if(!text) return;
      text = text.replace(/<strong>(.+?)<\/strong>/g,'*$1*');
      text = text.replace(/<ins>(.+?)<\/ins>/g,'__$1__');
      text = text.replace(/<em>(.+?)<\/em>/g,'_$1_');
      this.handler = text;
  },
  methods:{
    change(){
        var text = this.handler;
        text = text.replace(/\*(.+?)\*/g,'<strong>$1</strong>');
        text = text.replace(/__(.+?)__/g,'<ins>$1</ins>');
        text = text.replace(/_(.+?)_/g,'<em>$1</em>');
        this.$emit('change',text);
    },
  }

}
</script>
